import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DataTable from '../../../../../Common/DataTable';
import {
  DeleteUnitPayload, DriverExpensePayload, UnitListingData,
  UnitToTestProp,
  UpdatedBidDetailsValues,
} from '../../utils/types';
import { UnitListingColumns } from '../../utils/constants';
import EndPoints from '../../../../../Routes/EndPoints';
import { RootState } from '../../../../../redux/rootState';
import {
  deleteUnitStart, getAssociatedUnitsStart, getDriverExpenseStart, resetAssociatedUnits,
  setIsBidPricingUpdated,
  setUpdatedBidDetailsValues,
} from '../../redux/bidWorksheetSlice';
import { assignBidPricing, formatUnitListingData } from '../../utils/helper';
import { AddUnitModal } from './addUnitModal';
import ComponentDeleteModal from '../../../../../Common/DeleteModal/ComponentDeleteModal';
import ComponentConfirmModal from '../../../../../Common/UnitSelectorConfirmationModal/UnitConfirmationModal';

function ComponentUnitToTest({ watch, setValue }:UnitToTestProp) {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  const navigate = useNavigate();
  const {
    bidId, unitList, totalUnits, updatedBidDetails, selectedBid, isBidPricingUpdated,
  } = useSelector((state:RootState) => state.bidsReducer);
  const {
    selectedJob,
  } = useSelector((state:RootState) => state.jobStarterReducer);

  const dispatch = useDispatch();
  const bidPricingValues = watch();

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    return () => {
      dispatch(resetAssociatedUnits());
    };
  }, []);

  const handleData = () => {
    const payload = {
      page,
      rowsPerPage,
      searchQuery,
      bidId,
    };

    dispatch(getAssociatedUnitsStart(payload));
  };

  const handleButtonClick = () => {
    if (Object.keys(updatedBidDetails)?.length > 0 || isBidPricingUpdated) {
      setShowConfirmModal(true);
    } else {
      setShowModal(true);
    }
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleDelete = (unitId:string) => {
    setSelectedId(unitId);
    setDeleteModal(true);
  };
  const handleDeleteModal = () => {
    const payload:DeleteUnitPayload = {
      unitId: selectedId,
      bidId,
    };
    dispatch(deleteUnitStart(payload));
    setDeleteModal(false);
  };

  const handleEdit = (unitId:string) => {
    navigate(`${EndPoints.UNIT}/${unitId}`);
  };

  // const handleSave = () => {
  //   const bidPayload = selectedBid?.BidDetails;
  //   const bidPricingPayload = constructBidPricingPayload(bidPricingValues);
  //   const payload: UpdateBidPayload = {
  //     BidId: bidId,
  //     BidDetails: { ...bidPayload, JobId: selectedBid?.BidDetails.JobId },
  //     BidPriceDetails: bidPricingPayload,
  //   };
  //   dispatch(updateBidStart(payload));
  // };
  useEffect(() => {
    if (selectedJob?.JobInfo?.SiteId) {
      let round = 0;
      let gulf = false;
      if (Object.keys(updatedBidDetails).length > 0) {
        round = updatedBidDetails.roundTripMiles;
        gulf = updatedBidDetails.gulfCoastFL;
      } else {
        round = selectedBid?.BidDetails?.RoundTripMiles || 0;
        gulf = selectedBid?.BidDetails?.GulfCoastFL || false;
      }
      const IsBidNonMinimum = selectedBid?.BidDetails?.IsBidNonMinimum;
      const payload:DriverExpensePayload = {
        roundTripMiles: round || 0,
        calculatedDays: Number(bidPricingValues?.calculatedDays) || 0,
        overridedays: Number(bidPricingValues?.overRideDays) || 0,
        siteId: selectedJob?.JobInfo?.SiteId,
        gulfCoastFL: gulf || false,
        airfare: Number(bidPricingValues?.airfare) || 0,
      };
      const payload2 = { ...payload, IsBidNonMinimum };

      dispatch(getDriverExpenseStart(selectedBid?.BidId ? payload2 : payload));
    }
  }, [bidPricingValues?.airfare]);

  const handleReload = () => {
    dispatch(setUpdatedBidDetailsValues({} as UpdatedBidDetailsValues));
    dispatch(setIsBidPricingUpdated(false));
    assignBidPricing(setValue, selectedBid);
    setShowConfirmModal(false);
    setShowModal(true);
  };

  return (
    <>
      <DataTable<UnitListingData>
        handleButtonClick={handleButtonClick}
        data={formatUnitListingData(unitList) || []}
        columns={UnitListingColumns}
        totalRecords={totalUnits}
        buttonText="Add Unit"
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        searchQuery={searchQuery}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        setSearchQuery={setSearchQuery}
        handleData={handleData}
      />
      <AddUnitModal handleClose={handleClose} showModal={showModal} watch={watch} />
      <ComponentDeleteModal
        show={showDeleteModal}
        setOpenFrom={() => setDeleteModal(false)}
        handleDelete={handleDeleteModal}
      />
      <ComponentConfirmModal
        show={showConfirmModal}
        setOpenFrom={() => setShowConfirmModal(false)}
        handleClick={handleReload}
      />
      <br />
      {/* <Grid item xs={12} sm={12} md={12}>
        <div className="save_and_next_div">
          <Button type="submit" className="button_save_and_next" onClick={handleSave}>Save</Button>
        </div>
      </Grid> */}
    </>
  );
}
export default ComponentUnitToTest;
